/** Desaturated severity chip (design.md §2/§5). Color is paired with a label — never hue alone. */
export type Severity = 'critical' | 'warn' | 'pass' | 'info';

const LABEL: Record<Severity, string> = {
  critical: 'Critical',
  warn: 'Warning',
  pass: 'Pass',
  info: 'Info',
};

export function SeverityChip({ severity, label }: { severity: Severity; label?: string }) {
  return <span className={`chip chip--${severity}`}>{label ?? LABEL[severity]}</span>;
}
